// ChevronUp icon matching EBX UI component library design
function ChevronUpIcon({
  size = 16,
  color = 'currentColor',
}: {
  size?: number;
  color?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fill={color}
        d="m3.172 9.744 4.433-4.247c.127-.125.266-.197.405-.197a.55.55 0 0 1 .385.155l4.433 4.247c.223.213.23.565.017.787a.554.554 0 0 1-.787.016L8.01 6.647l-4.068 3.897a.554.554 0 0 1-.787-.016.55.55 0 0 1 .017-.784"
      />
    </svg>
  );
}

export default ChevronUpIcon;
